import SearchBar from './search-bar.vue'

export default SearchBar
